// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3j0bC","importantInfo":"styles_importantInfo__3_L25"};